import { AlarmModel, AlarmPeriodLimitModel } from "app/models/alarm.model";

type EditableAlarmFields = Pick<
    AlarmModel,
    | "id"
    | "name"
    | "description"
    | "field"
    | "window"
    | "threshold"
    | "limit"
    | "periodLimits"
    | "severity"
    | "notify"
    | "notificationChannelIds"
    | "silent"
    | "needACK"
    | "ignoredDevices"
>;

type EditableAlarm = Partial<EditableAlarmFields>;

function clonePeriodLimits(periodLimits?: AlarmPeriodLimitModel[]): AlarmPeriodLimitModel[] {
    return (periodLimits ?? []).map((periodLimit) => ({
        periodName: periodLimit.periodName,
        limit: periodLimit.limit,
    }));
}

export function cloneAlarmForForm<T extends EditableAlarm>(alarm: T): T {
    return {
        ...alarm,
        notificationChannelIds: [...(alarm.notificationChannelIds ?? [])],
        periodLimits: clonePeriodLimits(alarm.periodLimits),
        ignoredDevices: [...(alarm.ignoredDevices ?? [])],
    };
}

export function cloneAlarmForDuplicate<T extends EditableAlarm>(alarm: T): T {
    const duplicate = cloneAlarmForForm(alarm);

    delete duplicate.id;
    duplicate.name = duplicate.name ? `${duplicate.name} (copy)` : "(copy)";

    return duplicate;
}
